import { CaslAction, CaslSubject } from ':helpers/casl/casl.enum';

/**
 * Canonical map of which actions are legal for each subject.
 * Used for write-time validation of PolicyStatement (D8).
 */
export const LEGAL_ACTIONS_BY_SUBJECT: Record<CaslSubject, CaslAction[]> = {
    [CaslSubject.ALL]: [CaslAction.MANAGE],

    [CaslSubject.USER]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.RESTAURANT]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.USER_RESTAURANT]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.CREDENTIAL]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.SUBSCRIPTION]: [CaslAction.READ, CaslAction.UPDATE, CaslAction.MANAGE],

    [CaslSubject.PLATFORM]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.MEDIA]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.KEYWORD]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.REVIEW]: [
        CaslAction.CREATE,
        CaslAction.READ,
        CaslAction.UPDATE,
        CaslAction.DELETE,
        CaslAction.MANAGE,
        CaslAction.PUBLISH_WITHOUT_VALIDATION,
    ],

    [CaslSubject.POST]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.SEO_POST]: [
        CaslAction.CREATE,
        CaslAction.READ,
        CaslAction.UPDATE,
        CaslAction.DELETE,
        CaslAction.MANAGE,
        CaslAction.PUBLISH,
        CaslAction.PUBLISH_WITHOUT_VALIDATION,
    ],

    [CaslSubject.SOCIAL_POST]: [
        CaslAction.CREATE,
        CaslAction.READ,
        CaslAction.UPDATE,
        CaslAction.DELETE,
        CaslAction.MANAGE,
        CaslAction.PUBLISH,
        CaslAction.PUBLISH_WITHOUT_VALIDATION,
    ],

    [CaslSubject.TEMPLATE]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.RESTAURANT_HASHTAG]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.COMMENT]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.LABEL]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.CLIENT]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.CAMPAIGN]: [CaslAction.CREATE, CaslAction.READ, CaslAction.UPDATE, CaslAction.DELETE, CaslAction.MANAGE],

    [CaslSubject.FEEDBACK]: [
        CaslAction.CREATE,
        CaslAction.READ,
        CaslAction.UPDATE,
        CaslAction.DELETE,
        CaslAction.MANAGE,
        CaslAction.ANSWER,
    ],

    [CaslSubject.VERIFICATION_EMAIL]: [CaslAction.SEND],
};

export function isLegalActionForSubject(action: CaslAction, subject: CaslSubject): boolean {
    const legalActions = LEGAL_ACTIONS_BY_SUBJECT[subject];
    if (!legalActions) {
        return false;
    }
    return legalActions.includes(action);
}
